import { render, staticRenderFns } from "./EventHistoryAddedNewAdditionalCategoriesParams.vue?vue&type=template&id=1bc385e5"
import script from "./EventHistoryAddedNewAdditionalCategoriesParams.vue?vue&type=script&lang=js"
export * from "./EventHistoryAddedNewAdditionalCategoriesParams.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports